import { Modal, Button } from 'react-bootstrap';

export const ModalEmpresa = (props) => {
    const {empresa, categoriasEmpresa, showModal, setShowModal} = props;
    
    return (
        <Modal show={showModal} centered size="lg" scrollable >
				<Modal.Header className="align-items-center">
					<Modal.Title className="m-0 text-start">
						{empresa.nombreEmpresa}
					</Modal.Title>
					
				</Modal.Header>
				<Modal.Body>
                    <div className="d-flex flex-column flex-md-row gap-4">
                    {/* Imagen de perfil */}
                    <div className="flex-shrink-0 text-center">
                        <img
                        src={empresa.img && empresa.img}
                        alt="Logo Empresa"
                        className="rounded-circle shadow"
                        style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                        />
                    </div>

                    {/* Información */}
                    <div className="flex-grow-1">
                        <p><strong>Teléfono:</strong> {empresa.telefono}</p>
                        <p><strong>Dirección:</strong> {empresa.direccion}</p>
                        <p><strong>Localidad:</strong> {empresa.localidad?.nombre}</p>
                        <p>
                            <strong>Categorias: </strong> 
                            {categoriasEmpresa.map((categoria)=>(
                                categoria[0].empresa_id===empresa.id &&
                                    categoria[0].categoria_id.nombre
                            ))}
                        </p>
                    </div>
                    </div>
                </Modal.Body>
				<Modal.Footer className="d-flex justify-content-rigth">
					<Button className='btn login-boton' onClick={()=>setShowModal(false)}>
						Cerrar
					</Button>
				</Modal.Footer>
			</Modal>
    )
}